<script lang="ts">
    import type {TabId, TabPageDefinitionsMap} from 'shared/ui-widgets/tabset/types';
    import {exists} from 'shared/utils/custom-utils';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let tabs: TabPageDefinitionsMap;
    export let activeTab: TabId;

    $: component = tabs[activeTab]?.component;
    $: props = tabs[activeTab]?.props ?? {};
</script>

{#if exists(component)}
    <svelte:component this="{component}" {...props}/>
{:else}
    <IconedContent fillAvailableSpace icon="exclamation" orientation="vertical" align="center" justify="center">
        Nenachází se zde žádná záložka. Pravděpodobně nemáte práva.
    </IconedContent>
{/if}
